import React from 'react';
import PropTypes from 'prop-types';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import EvolvedMenu from './Menu/EvolvedMenu';
import { Footer } from './Footer';
import styled from '@emotion/styled';

import {  Paper, ThemeProvider } from '@mui/material';
import { sweatTheme } from '../theme';
import { flexColumn } from './common/styled';
import { css, Global } from '@emotion/react';

const globalStyles = css`
  html {
    --measure: 60ch;
    --small: 12px;
    --medium: 24px;
    --color-primary: #36131f;
    --grey: #e5e5e5;

    --ratio: 1.5;
    --s-5: calc(var(--s-4) / var(--ratio));
    --s-4: calc(var(--s-3) / var(--ratio));
    --s-3: calc(var(--s-2) / var(--ratio));
    --s-2: calc(var(--s-1) / var(--ratio));
    --s-1: calc(var(--s0) / var(--ratio));
    --s0: 1rem;
    --s1: calc(var(--s0) * var(--ratio));
    --s2: calc(var(--s1) * var(--ratio));
    --s3: calc(var(--s2) * var(--ratio));
    --s4: calc(var(--s3) * var(--ratio));
    --s5: calc(var(--s4) * var(--ratio));
  }
`;

const SiteContainer = styled.div`
  ${flexColumn};
  min-height: 100vh;
  background: #f0f2f5;

  p {
    padding-left: 6px;
    max-width: var(--measure);
  }
`;

const ContentContainer = styled(Container)`
  && {
    font-size: 1rem;
    flex: 1;
    padding: 0;
    max-width: calc(var(--measure) * var(--ratio));
  }
`;

const ContentPaper = styled(Paper)`
  && {
    padding: var(--small);
    @media (min-width: 640px) {
      margin: var(--small);
      padding: var(--medium);
    }
  }
`;

const Layout: React.FC = ({ children }) => {
  return (
    <ThemeProvider theme={sweatTheme}>
      <SiteContainer>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Roboto:300,400,500&display=swap"
        />
        <CssBaseline />
        <Global styles={globalStyles} />
        <EvolvedMenu />
        <ContentContainer component="main">
          <ContentPaper>{children}</ContentPaper>
        </ContentContainer>
        <Footer />
      </SiteContainer>
    </ThemeProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
